import { gql } from '@apollo/client'
import { FIELD_FRAGMENT } from 'graphql/field/queries'

// fragments
export const PLAN_OBJECTIVE_DETAILS_FRAGMENT = gql`
  fragment PLAN_OBJECTIVE_DETAILS on PlanObjective {
    id
    color
    archived
    planTypeId
    typeOptionId
    description
    createdAt
    commencementAt
    completionAt
    completionPercentage
    isBookmark
    ownedById
    ownedByUser {
      id
      firstName
      lastName
    }
    ownedByPosition {
      id
      description
      user {
        id
        firstName
        lastName
      }
    }
    memberPositions {
      id
      description
    }
    memberUsers {
      id
      firstName
      lastName
    }
    planItems {
      data {
        id
        path
        planId
        plan {
          id
          companyId
          ownedById
          locked
          memberPositions {
            id
          }
          memberUsers {
            id
          }
          private
          parentPlanId
          name
          scheduleDefaults {
            entityType
            levelId
            repeating
            repeatEveryValue
            repeatEveryType
            periodEndsOn
            startPeriod
            endPeriod
            endsOn
            endsOnDate
            reviewDate {
              date
              end
              value
              period
            }
          }
          planType {
            id
            description
            levels {
              id
              color
              position
              description
              typeOptions {
                id
                label
              }
            }
            objectiveOwnerObjectSecurityId
            objectiveMemberObjectSecurityId
            actionOwnerObjectSecurityId
            actionMemberObjectSecurityId
            kpiOwnerObjectSecurityId
            kpiMemberObjectSecurityId
            planOwnerObjectSecurityId
            planMemberObjectSecurityId
          }
          planItems(pagination: { pageTake: 10000, pageSkip: 0 }) {
            data {
              id
              parentId
              treePosition
              referenced
              planAction {
                id
              }
              planKPI {
                id
              }
              planObjective {
                id
              }
            }
          }
        }

        referenced
      }
    }
    fields {
      ...FIELD
    }
    fieldValueMap {
      fieldName
      fieldValue
      fieldType
    }
  }
  ${FIELD_FRAGMENT}
`

export const PLAN_OBJECTIVE_LINKED_ITEMS_FRAGMENT = gql`
  fragment PLAN_OBJECTIVE_LINKED_ITEMS on PlanObjective {
    destinationLinkingItems {
      id
      parentId
      weighting
      createdAt
      description
      sourcePlanKPIId
      destinationPlanKPIId
      sourcePlanActionId
      destinationPlanActionId
      sourcePlanObjectiveId
      destinationPlanObjectiveId
      sourcePlanKPI {
        id
        description
        destinationLinkingItems {
          id
        }
        sourceLinkingItems {
          id
        }
        planItems {
          data {
            id
            path
            plan {
              id
              name
            }
            referenced
          }
        }
      }
      destinationPlanKPI {
        id
        description
        destinationLinkingItems {
          id
        }
        sourceLinkingItems {
          id
        }
        planItems {
          data {
            id
            path
            plan {
              id
              name
            }
            referenced
          }
        }
      }
      sourcePlanAction {
        id
        description
        destinationLinkingItems {
          id
        }
        sourceLinkingItems {
          id
        }
        planItems {
          data {
            id
            path
            plan {
              id
              name
            }
            referenced
          }
        }
      }
      destinationPlanAction {
        id
        description
        destinationLinkingItems {
          id
        }
        sourceLinkingItems {
          id
        }
        planItems {
          data {
            id
            path
            plan {
              id
              name
            }
            referenced
          }
        }
      }
      sourcePlanObjective {
        id
        description
        destinationLinkingItems {
          id
        }
        sourceLinkingItems {
          id
        }
        planItems {
          data {
            id
            path
            plan {
              id
              name
            }
            referenced
          }
        }
      }
      destinationPlanObjective {
        id
        description
        destinationLinkingItems {
          id
        }
        sourceLinkingItems {
          id
        }
        planItems {
          data {
            id
            path
            plan {
              id
              name
            }
            referenced
          }
        }
      }
    }
    sourceLinkingItems {
      id
      parentId
      weighting
      createdAt
      description
      sourcePlanKPIId
      destinationPlanKPIId
      sourcePlanActionId
      destinationPlanActionId
      sourcePlanObjectiveId
      destinationPlanObjectiveId
      sourcePlanKPI {
        id
        description
        destinationLinkingItems {
          id
        }
        sourceLinkingItems {
          id
        }
        planItems {
          data {
            id
            path
            plan {
              id
              name
            }
            referenced
          }
        }
      }
      destinationPlanKPI {
        id
        description
        destinationLinkingItems {
          id
        }
        sourceLinkingItems {
          id
        }
        planItems {
          data {
            id
            path
            plan {
              id
              name
            }
            referenced
          }
        }
      }
      sourcePlanAction {
        id
        description
        destinationLinkingItems {
          id
        }
        sourceLinkingItems {
          id
        }
        planItems {
          data {
            id
            path
            plan {
              id
              name
            }
            referenced
          }
        }
      }
      destinationPlanAction {
        id
        description
        destinationLinkingItems {
          id
        }
        sourceLinkingItems {
          id
        }
        planItems {
          data {
            id
            path
            plan {
              id
              name
            }
            referenced
          }
        }
      }
      sourcePlanObjective {
        id
        description
        destinationLinkingItems {
          id
        }
        sourceLinkingItems {
          id
        }
        planItems {
          data {
            id
            path
            plan {
              id
              name
            }
            referenced
          }
        }
      }
      destinationPlanObjective {
        id
        description
        destinationLinkingItems {
          id
        }
        sourceLinkingItems {
          id
        }
        planItems {
          data {
            id
            path
            plan {
              id
              name
            }
            referenced
          }
        }
      }
    }
  }
`

export const PLAN_OBJECTIVE_REVIEWS_FRAGMENT = gql`
  fragment PLAN_OBJECTIVE_REVIEWS on PlanObjective {
    scheduledReviews {
      id
      planId
      companyId
      repeating
      repeatEveryValue
      repeatEveryType
      periodEndsOn
      startPeriod
      endPeriod
      scheduledReviewers {
        id
        userId
        positionId
        scheduledReviewId
        reviewDate {
          end
          value
          date
          period
        }
        user {
          id
          firstName
          lastName
          avatarUrl
        }
        position {
          id
          description
        }
      }
      endsOn
      endsOnDate
    }
    reviews {
      id
      planId
      createdAt
      updatedAt
      startPeriod
      endPeriodAt
      dueAt
      scheduledReviewId
      scheduledReview {
        id
        planId
        companyId
        repeating
        repeatEveryValue
        repeatEveryType
        periodEndsOn
        startPeriod
        endPeriod
        scheduledReviewers {
          id
          userId
          positionId
          scheduledReviewId
          reviewDate {
            end
            value
            date
            period
          }
          user {
            id
            firstName
            lastName
            avatarUrl
          }
          position {
            id
            description
          }
        }
        endsOn
        endsOnDate
      }
      status
      values {
        goals
        doWell
        doBetter
      }
      fieldValueMap {
        fieldId
        fieldValueId
        fieldValue
        fieldLabel
      }
      updatedBy {
        id
        firstName
        lastName
      }
    }
  }
`

export const PLAN_OBJECTIVE_PERMISSIONS_FRAGMENT = gql`
  fragment PLAN_OBJECTIVE_PERMISSIONS on PlanObjective {
    currentPermissions {
      objectiveArchiveObjective
      objectiveAddAction
      objectiveAddKPI
      objectiveAddObjective
      objectiveCreateResource
      objectiveCreateScheduledReview
      objectiveDeleteObjective
      objectiveDeleteResource
      objectiveDeleteScheduledReview
      objectiveLinkObjects
      objectiveModifyObjective
      objectiveModifyResource
      objectiveModifyScheduledReview
      objectiveSetUserObjectiveSecurity
      objectiveViewCompletedReview
      objectiveViewInProgressReview
      planLinkObjects
    }
  }
`

// queries
export const PLAN_OBJECTIVE_DETAILS_QUERY = gql`
  query PLAN_OBJECTIVE_DETAILS_QUERY($filter: PlanObjectiveFilterInput!) {
    planObjectives(filter: $filter) {
      pagination {
        pageSkip
        pageTake
        totalCount
      }
      data {
        ...PLAN_OBJECTIVE_DETAILS
        ...PLAN_OBJECTIVE_LINKED_ITEMS
        ...PLAN_OBJECTIVE_REVIEWS
        ...PLAN_OBJECTIVE_PERMISSIONS
      }
    }
  }
  ${PLAN_OBJECTIVE_DETAILS_FRAGMENT}
  ${PLAN_OBJECTIVE_LINKED_ITEMS_FRAGMENT}
  ${PLAN_OBJECTIVE_REVIEWS_FRAGMENT}
  ${PLAN_OBJECTIVE_PERMISSIONS_FRAGMENT}
`

export const PLAN_OBJECTIVE_ACTIVITIES_LIST_QUERY = gql`
  query PLAN_OBJECTIVE_ACTIVITIES_LIST_QUERY($filter: LogFilterInput!) {
    logs(filter: $filter) {
      data {
        id
        entityType
        entityId
        actionType
        createdAt
        metadata {
          fileName
          fileUrl
          fileContentType
          comment
          resource
        }
        user {
          id
          firstName
          lastName
          avatarUrl
        }
        objective {
          id
          description
        }
      }
    }
  }
`

export const PLAN_OBJECTIVE_RESOURCES_LIST_QUERY = gql`
  query PLAN_OBJECTIVE_RESOURCES_LIST_QUERY($filter: PlanResourcesFilterInput!) {
    planResources(filter: $filter) {
      data {
        id
        planObjectiveId
        planActionId
        createdBy {
          id
          firstName
          lastName
          avatarUrl
        }

        createdAt
        updatedAt
        fieldValueMap {
          fieldName
          fieldValue
          fieldType
          wysiwyg
        }
      }
    }
  }
`

export const PLAN_OBJECTIVE_LIST_QUERY = gql`
  query PLAN_OBJECTIVE_LIST_QUERY(
    $filter: PlanObjectiveFilterInput!
    $order: OrderInput
    $pagination: PaginationInput
  ) {
    planObjectives(filter: $filter, order: $order, pagination: $pagination) {
      pagination {
        pageSkip
        pageTake
        totalCount
      }
      data {
        id
        description
        planItems(filter: { referenced: false }) {
          data {
            id
            plan {
              id
              name
              companyId
            }
          }
        }
        ownedByUser {
          id
          firstName
          lastName
        }
        ownedByPosition {
          id
          description
          user {
            id
            firstName
            language
          }
        }
        fieldValueMap {
          fieldName
          fieldValue
        }
        ...PLAN_OBJECTIVE_REVIEWS
      }
    }
  }
  ${PLAN_OBJECTIVE_REVIEWS_FRAGMENT}
`
